import React, { useEffect } from "react";
import "./hors-connexion.scss";

/**
 * Gabarit des écrans hors connexion du portail (connexion, mot de passe
 * oublié, nouveau mot de passe, activation, confirmation de présence en EP),
 * porté du BOA (maquettes 05 à 07 validées par la Caf) : volet marque à
 * gauche, carte à droite, une colonne sous 900 px. Le volet porte le logo :
 * la barre d'en-tête de l'application est masquée tant que la page est
 * affichée (classe `sans-en-tete` sur <body>, cf. coquille.scss).
 */
const PageHorsConnexion = ({ children }) => {
  useEffect(() => {
    document.body.classList.add("sans-en-tete");
    return () => document.body.classList.remove("sans-en-tete");
  }, []);

  return (
    <div className="hors-connexion hc">
      <aside className="marque" aria-label="Présentation d'ESPOAR">
        <div className="disque" />
        <div>
          <img className="logo" src="/assets/logo-espoar-new.png" alt="ESPOAR" />
          <p className="titre-marque">Espace allocataire</p>
          <p className="accroche">
            Votre accompagnement RSA à La Réunion : questionnaire d'orientation, rendez-vous et
            documents, au même endroit.
          </p>
        </div>
        <div className="pied">
          <span className="caf">
            <img src="/assets/logo-espoar.png" alt="Caf de La Réunion" />
          </span>
          <span>Une plateforme de la Caf de La Réunion</span>
        </div>
      </aside>
      <div className="acces">
        <div className="carte">{children}</div>
      </div>
    </div>
  );
};

export default PageHorsConnexion;
